var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralRecirculation = function SvgDAhuGeneralRecirculation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "354,324 354,326 351,329 349,329 346,326 346,324 346,210 346,208 349,205 351,205 354,208 354,210",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 207,
    width: 1,
    height: 120,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349,
    y: 203,
    width: 2,
    height: 128,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354,327 353,327 353,207 354,207",
    fill: "#787878"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 261.9,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,251.9c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S301.5,251.9,307,251.9 M307,250.9c-6.1,0-11,4.9-11,11 c0,6.1,4.9,11,11,11s11-4.9,11-11S313.1,250.9,307,250.9L307,250.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.4,258.6l1.6,4.4l1.6-4.4h1.3v5.7h-1v-1.9l0.1-2.5l-1.7,4.4h-0.7l-1.7-4.4l0.1,2.5v1.9h-1v-5.7L305.4,258.6 L305.4,258.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 246,
    width: 60,
    height: 32,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,247v30h-58v-30H379 M380,246h-60v32h60V246L380,246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 366.7,
    y: 244.3,
    transform: "matrix(0.8795 -0.4759 0.4759 0.8795 -80.458 206.3416)",
    width: 1,
    height: 35.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.2,
    cy: 262,
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 315.2,
    y: 261.6,
    transform: "matrix(0.4767 -0.8791 0.8791 0.4767 -56.2059 429.7303)",
    width: 35.2,
    height: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.8,
    cy: 262,
    r: 2
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 260.9,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "343.1,221.5 356.9,221.5 350,233",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,222l-6,10l-6-10H356 M357.8,221h-15.5l0.9,1.5l6,10l0.9,1.4l0.9-1.4l6-10L357.8,221L357.8,221L357.8,221 z",
    fill: "#FFFFFF"
  })))));
};
export default SvgDAhuGeneralRecirculation;